import React, { Component, useEffect } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';

import Body from '../Components/layout/Body';
import { IMPORTANCE_BUTTONS } from './ConstImportanceBtns';

const INDEP_HELP = `
  <div>
    <p><strong>Purpose:</strong>  Here you and the client discuss their *preferences* about how much support they receive from other people.  
    This may help you select an access method that fits the client’s preference.</p>
    <p>Note that setup may be a bit different from usage – 
    some people are OK with getting some help with setup, say once a day or so, but they may want to be fully independent once during usage, once setup is complete.</p>
    <p>If complete independence is very important to the client, keep that in mind when trying out different access methods.  
    Sometimes it may not be possible to meet the client’s preferences here, but having the conversation will put you in a good position to work together on this.</p>
    <p>Note that we don’t specifically ask about how much support from others is actually available to the client.  
    But this can be important, too, especially in cases where they may need a complex access method but not really have the support from others to get it going.</p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  indepSetup: PropTypes.string,
  indepUse: PropTypes.string,
  onChangeIndepSetup: PropTypes.func.isRequired,
  onChangeIndepUse: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  indepSetup: '',
  indepUse: ''
};


//content sub-component with unique content for this page
class ContextsIndependenceContent extends Component {
  constructor(props){
    super(props);
  }

  //Render the form for the main goal.
  //Calls the setter that's passed in by the parent, when a radio button is clicked.
  //That setter changes the state of the mainGoal in the parent, 
  //which triggers a new render of the view with the new goal.

  render(){
    const firstName = this.props.firstName;
    const pronouns = this.props.pronouns;
    const indepSetup = this.props.indepSetup;
    const onChangeIndepSetup = this.props.onChangeIndepSetup;
    const indepUse = this.props.indepUse;
    const onChangeIndepUse = this.props.onChangeIndepUse;

    console.log("rendering GatherInfoContextsIndependence subcomp, indepSetup: " + indepSetup + " indepUse: " + indepUse);
    
    return(
    <>
    <Form>
      <FormGroup tag="fieldset">
        <legend>Setup - For {firstName}, how important is it to be completely independent in <em>setting up</em> {pronouns[2]} access method?</legend>
        {IMPORTANCE_BUTTONS.map((btn, index) =>
          <FormGroup check key={index}>
            <Input
              id={btn.value+"-setup"}
              value={btn.value}
              checked={indepSetup===btn.value}
              onChange={onChangeIndepSetup}
              name="indep-setup"
              type="radio"
            />
            {' '}
            <Label for={btn.value+"-setup"} check>
              {btn.label}
              {' '}
              <span className="aa-more-info">{btn.moreInfo}</span>
            </Label>
          </FormGroup>
        )}
      </FormGroup>
      <FormGroup tag="fieldset">
        <legend>Use - And how important is it to be completely independent in <em>using</em> {pronouns[2]} access method?</legend>
        {IMPORTANCE_BUTTONS.map((btn, index) =>
          <FormGroup check key={index}>
            <Input
              id={btn.value+"-use"}
              value={btn.value}
              checked={indepUse===btn.value}
              onChange={onChangeIndepUse}
              name="indep-use"
              type="radio"
            />
            {' '}
            <Label for={btn.value+"-use"} check>
              {btn.label}
              {' '}
              <span className="aa-more-info">{btn.moreInfo}</span>
            </Label>
          </FormGroup>
        )}
      </FormGroup>
    </Form>
    <p>Tip: If complete independence is very important to {firstName}, keep that in mind when trying out different access methods.</p>
    </>
    );
  }
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component.
//since the main goal step includes a form, receive the initial form values via props,
//along with setters to change those values based on the form input.
function GatherInfoContextsIndependence(props) {
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  const indepSetup = props.indepSetup;
  const onChangeIndepSetup = props.onChangeIndepSetup;
  const indepUse = props.indepUse;
  const onChangeIndepUse = props.onChangeIndepUse;
  const saveFormData = props.saveFormData;
  const onContinue = props.onContinue;

  console.log("rendering GatherInfoContextsIndependence, indepSetup: " + indepSetup + " indepUse: " + indepUse);

  const pageData = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-users",
    pageSymbolClassName: "aa-section-symbol gather",

    title: `Consider ${firstName}'s preferences about support from other people.`,
    subTitle: "Specifically for access setup and troubleshooting when needed.",
    learnMore: {linkText: "Learn More about why we ask about preferences for personal support",
                title: "Personal Support",
                content: INDEP_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true
  }

  useEffect(() => {
    console.log('GIGPositions mounted');
    return () => {
      console.log('GIGPos unmounting and saving...');
      saveFormData();
    }
  }, [saveFormData])

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <ContextsIndependenceContent 
          firstName={firstName}
          pronouns={pronouns}
          indepSetup={indepSetup} 
          onChangeIndepSetup={onChangeIndepSetup}
          indepUse={indepUse} 
          onChangeIndepUse={onChangeIndepUse}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

GatherInfoContextsIndependence.propTypes = propTypes;
GatherInfoContextsIndependence.defaultProps = defaultProps;

export default GatherInfoContextsIndependence;